import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export interface HelpTooltipProps {
  children?: React.ReactNode;
  content: React.ReactNode;
  className?: string;
  iconClassName?: string;
}

export const HelpTooltip = ({ children, content, className, iconClassName }: HelpTooltipProps) => {
  return (
    <div className="flex items-center gap-1">
      {children}
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Info className={cn("size-4 cursor-help text-blue-500", iconClassName)} />
          </TooltipTrigger>
          <TooltipContent className={className}>
            <div className="max-w-64 text-sm">{content}</div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
